var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconForkKnife = function SvgIconForkKnife(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20.125 3a1 1 0 0 0-1.342-.94c-1.36.495-2.356 1.677-3.086 2.95-.743 1.295-1.297 2.835-1.706 4.28a37 37 0 0 0-.862 3.88 37 37 0 0 0-.233 1.593l-.011.094-.003.026v.007l-.001.002s0 .002.994.108l-.994-.107A1 1 0 0 0 13.875 16h4.25v5a1 1 0 1 0 2 0zm-5.024 10.502q-.045.268-.08.498h3.104V4.985a7.4 7.4 0 0 0-.693 1.02c-.628 1.096-1.13 2.462-1.517 3.83a35 35 0 0 0-.814 3.667",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 2a1 1 0 0 1 1 1v4.5a2.375 2.375 0 1 0 4.75 0V3a1 1 0 1 1 2 0v4.5a4.375 4.375 0 0 1-3.375 4.26V21a1 1 0 1 1-2 0v-9.24A4.376 4.376 0 0 1 3.5 7.5V3a1 1 0 0 1 1-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.875 3a1 1 0 1 0-2 0v3.75a1 1 0 0 0 2 0z"
  }))));
};
export default SvgIconForkKnife;